export default __webpack_public_path__ + "static/media/logo-nbc-full.506d7dad.svg";